import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaTools } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31090.149390425795!2d80.1590560786839!3d13.08215136012901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52666a322c7eed%3A0x15cbbff0d16a7972!2sIndelect%20Technologies.Pvt.Ltd!5e0!3m2!1sen!2sin!4v1632380457902!5m2!1sen!2sin";

const MapEmbed = () => (
  <div className="location-map-embed-wrapper">
    <iframe
      title="Indelect Technologies location map"
      src={MAP_EMBED_URL}
      className="location-map-embed"
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
);

const Location = () => {
  return (
    <div className="page-container location-page">
      <h1 className="main-heading">
        <FaMapMarkerAlt className="location-heading-icon" />
        Our Location
      </h1>
      <div className="location-card">
        <div className="location-map-block">
          <MapEmbed />
        </div>
        <div className="location-contact-block">
          <h2 className="google-maps-heading">Contact</h2>
          <p className="contact-address">
            <FaMapMarkerAlt className="location-contact-icon" />
            #15/53, 1st Floor, Thirunagar, Villivakkam, Chennai - 600 095
          </p>
          <p className="contact-email">
            <a href="mailto:salesindelect@gmail.com">
              <MdEmail className="location-contact-icon" />
              salesindelect@gmail.com
            </a>
          </p>
          <p className="contact-phone">
            <FaPhoneAlt className="location-contact-icon" /> Sales: +91 93802 43402
          </p>
          <p className="contact-phone">
            <FaTools className="location-contact-icon" /> Service: +91 93825 43299
          </p>
        </div>
      </div>
    </div>
  );
};

export default Location;
